/**
 * Filterings
 */
import clsx from 'clsx';
import React, { useState } from 'react';
import { Transition } from 'react-transition-group';
import { Icon } from 'ui-component-library/base';
/** The filterings component. */
var Filterings = function (_a) {
    var id = _a.id, heading = _a.heading, _b = _a.expanded, defaultExpanded = _b === void 0 ? false : _b, selectedBuckets = _a.selectedBuckets, className = _a.className, children = _a.children;
    var _c = useState(defaultExpanded), expanded = _c[0], setExpanded = _c[1];
    return (React.createElement("div", { "data-cid": "filterings", className: clsx(className, 'border-b border-greyLight') },
        React.createElement("button", { "aria-controls": "filtering-content-" + id, "aria-expanded": expanded, onClick: function () { return setExpanded(!expanded); }, className: "flex justify-between w-full py-4 px-3" },
            React.createElement("span", { className: "font-semibold" }, heading),
            React.createElement("span", null,
                !!selectedBuckets && selectedBuckets > 0 && (React.createElement("span", { className: "inline-block relative z-10 text-white text-sm w-8 mr-2 multieselect-dropdown-counter" }, selectedBuckets)),
                React.createElement(Icon, { icon: "chevron", color: "#00636A", "aria-hidden": "true", size: 0.75, direction: !expanded ? 'up' : 'down' }))),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: "filtering-content-" + id, className: clsx(state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in', 'mt-2'), hidden: state === 'exited' }, children)); })));
};
export default Filterings;
